import * as auth from 'Auth';
import constants from 'Constants';
import { isProduction } from 'utils/Config';
import consoleStore from 'stores/Console/ConsoleStore';


export function prefill() {
  if (!auth.isLoggedIn()) return;

  const user = consoleStore.user;
  if (!user) return;

  zE('webWidget', 'prefill', {
    name: {
      value: user.name,
    },
    email: {
      value: user.email,
    },
  });
}

export function open() {
  zE('webWidget', 'open');
}

export function show() {
  zE('webWidget', 'show');
}

export function hide() {
  zE('webWidget', 'hide');
}

export function reset() {
  zE('webWidget', 'reset');
}

